module.exports = __webpack_public_path__ + "df98e1468ed540f29a21ccdf6fa849e3.png";